import {assignEvaluations} from "./evaluateExpressions.js";
export default function deleteExpression(expression, workspace) {
  workspace.delete(expression.identifier);
  return assignEvaluations(workspace);
}
